import { Store } from 'redux';
import { ApplicationState } from './store';
import mockBlocks from 'mockBlocks';
import moduleBlocks from 'moduleBlocks';

const STORAGE_KEY = 'chameleon_v2';

if (window.location.hash.match('clear')) {
  const location = window.location.href.replace(/#.*$/, '');

  sessionStorage.clear();
  localStorage.clear();

  window.open(location, '_self');
  // window.close();
}

export const saveState = (store: Store) => () => {
  const state = { ...store.getState() };

  // Clear the undesired properties from the store
  delete state.focusedNodeId;
  delete state.lastFocusedNodeId;
  delete state.currentInteractionBlockId;

  // TODO: use this as ' bookmarking '
  // to be moved to someplace else
  // delete state.currentTopic;

  delete state.interactionsSeen;
  delete state.interactionsOpen;

  localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
};

export const clearState = () => {};

export const getState = (): ApplicationState => {
  if (window.savedStore) {
    const s = { ...window.savedStore };
    if (s.theme && Object.keys(s.theme).length <= 0) {
      delete s.theme;
    }
    return s;
  }
  return undefined;
  //return JSON.parse(localStorage.getItem('chameleon_v2')) as ApplicationState;
};

export const getLocalState = (): ApplicationState => {
  return JSON.parse(localStorage.getItem('chameleon_v2')) as ApplicationState;
};

type Callable = () => void;

export const watch = (store: Store): Callable => {
  let deBounce;

  const unsubscribe = store.subscribe(() => {
    clearTimeout(deBounce);
    deBounce = setTimeout(saveState(store), 250);
  });

  return unsubscribe;
};
